import React, { type FormEvent, type InputHTMLAttributes } from 'react'
import { cn } from 'shared-utilities'
import Button2026 from '../Button2026/Button2026'
import './InputButtonCombo2026.css'

export interface InputButtonCombo2026Props
  extends Omit<
    InputHTMLAttributes<HTMLInputElement>,
    'className' | 'onChange' | 'onSubmit' | 'value'
  > {
  buttonText: string
  value: string
  onChange: (value: string) => void
  onSubmit: (event: FormEvent<HTMLFormElement>) => void
  className?: string
  formClassName?: string
  formId?: string
  inputClassName?: string
  buttonClassName?: string
  buttonAriaLabel?: string
  onClear?: () => void
}

const InputButtonCombo2026 = ({
  id,
  placeholder,
  buttonText,
  value,
  onChange,
  onSubmit,
  type = 'text',
  required,
  disabled,
  className,
  formClassName,
  formId,
  inputClassName,
  buttonClassName,
  buttonAriaLabel,
  onClear,
  ...inputProps
}: InputButtonCombo2026Props) => {
  const showClearButton = Boolean(onClear && value.length > 0)

  return (
    <form
      id={formId}
      name={inputProps.name}
      onSubmit={onSubmit}
      className={cn('w-full', formClassName)}
    >
      <div className={cn('InputButtonCombo2026', className)}>
        <div className="InputButtonCombo2026__inner">
          <div className="InputButtonCombo2026__inputWrap">
            <label htmlFor={id} className="sr-only">
              {placeholder}
            </label>
            <input
              {...inputProps}
              id={id}
              type={type}
              value={value}
              required={required}
              disabled={disabled}
              placeholder={placeholder}
              onChange={(event) => onChange(event.target.value)}
              className={cn(
                'InputButtonCombo2026__input',
                showClearButton && 'InputButtonCombo2026__input--clearable',
                inputClassName
              )}
            />
            {showClearButton && (
              <button
                type="button"
                aria-label="Clear input"
                className="absolute inset-y-0 right-0 flex items-center justify-center px-3 text-xl text-white"
                onClick={onClear}
              >
                <i className="bx bx-x" aria-hidden="true" />
              </button>
            )}
          </div>
          <Button2026
            type="submit"
            variant="primary"
            disabled={disabled}
            aria-label={buttonAriaLabel ?? buttonText}
            className={cn('InputButtonCombo2026__submit', buttonClassName)}
          >
            {buttonText}
          </Button2026>
        </div>
      </div>
    </form>
  )
}

export default InputButtonCombo2026
